import { render, staticRenderFns } from "./radio-button-group.vue?vue&type=template&id=2634027a&scoped=true"
import script from "./radio-button-group.vue?vue&type=script&lang=ts"
export * from "./radio-button-group.vue?vue&type=script&lang=ts"
import style0 from "./radio-button-group.vue?vue&type=style&index=0&id=2634027a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634027a",
  null
  
)

export default component.exports